export default __webpack_public_path__ + "static/media/kickstarter.49609ca0.gif";